/* app/js/src/components/media-transcoder/jobs/packager/shaka-packager-job-report/shaka-packager-job-report.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  position: fixed;
  z-index: 22;
}
.container {
  position: absolute;
  transition: opacity ease-in 0.2s;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
  transform: translate(32%, 50%);
  background-color: white;
  width: 52vw;
  max-height: 80vh;
}
.container .header {
  cursor: move;
  background-color: #141b22;
  color: white;
  height: 6%;
  padding-left: 2vw;
  padding-right: 2vw;
}
.container .header .window-buttons {
  margin-top: 0.4vw;
}
.container .header h2 {
  margin: 0;
  padding: 0.4vw;
}
.container .body {
  max-height: 70vh;
  overflow: auto;
  background-color: white;
  padding: 1rem 1.5rem;
}
.container .report-loading {
  align-items: center;
  min-height: 8rem;
  padding: 2rem;
}
.container .report-loading-message {
  margin: 0;
  color: #6c757d;
  font-size: 0.95rem;
  font-weight: 500;
  text-align: center;
}
.container .report-loading-message.report-error {
  color: #c0392b;
}
.container .log-summary {
  margin-bottom: 1rem;
  font-size: 0.9rem;
}
.container .log-summary p {
  margin: 0.25rem 0;
}
.container .stages-table {
  width: 100%;
  margin-top: 0.5rem;
  border-collapse: collapse;
  font-size: 0.85rem;
}
.container .stages-table th,
.container .stages-table td {
  border: 1px solid #dee2e6;
  padding: 0.35rem 0.5rem;
  text-align: left;
}
.container .stages-table th {
  background: #f8f9fa;
}
.container .log-json {
  margin: 0;
  padding: 0.75rem;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  font-size: 0.75rem;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 40vh;
  overflow: auto;
}
/*# sourceMappingURL=shaka-packager-job-report.component.css.map */
